import React from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";

import { greyDark } from "../../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  carrierInfoStyles: {
    color: greyDark,
    width: "50%",
    "& p": {
      margin: "4px 0",
      fontSize: "12px",
    },
    [down("xs")]: {
      position: "absolute",
      right: "10px",
      top: "30px",
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  desktopInfo: {
    [down("xs")]: {
      display: "none",
    },
  },
}));

const CarrierInfo = ({ carrierInfo, operatedBy, airlines }) => {
  const { carrierInfoStyles, desktopInfo } = useStyles();

  const airlineInfo = airlines[carrierInfo.airline] ?? {
    'img': process.env.PUBLIC_URL + `/icons/airline/${carrierInfo?.airline}.png`,
    'code': carrierInfo.airline,
    'name': carrierInfo.airline,

  };
  return (
    <Box className={carrierInfoStyles}>
      <Box mb={1}>
        <img
          src={airlineInfo.img}
          style={{ maxWidth: "110px" }}
          alt={airlineInfo.name}
        />
      {operatedBy && (
        <Typography
            className={desktopInfo}
            color="primary">
            Operated by {operatedBy}
        </Typography>
      )}
      </Box>
      <Box className={desktopInfo}>
        <p>{`${carrierInfo?.code} | ${carrierInfo?.type}`}</p>
        <p>{carrierInfo?.plane}</p>
      </Box>
    </Box>
  );
};

export default CarrierInfo;
